import LocalAtmIcon from '@mui/icons-material/LocalAtm';
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const binaryIncomeDetails = {
    id: 'binaryIncomeDetails',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'binaryIncomeDetails',
            title: 'Binary Income Details',
            type: 'item',
            url: '/binary-income',
            icon: LocalAtmIcon,
            breadcrumbs: false,
            
        }
    ]
};

export default binaryIncomeDetails;
